/* updating flight info details using commmit end point and restricting the page navigation by passing redirect */
import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import { MODAL } from 'constants';
import { openModal } from 'actions/modal/openModal';
import { closeModal } from 'actions/modal/closeModal';

export const updateFlightInfoDetails =
  ({ sourceCode } = {}, { redirect = true } = {}) =>
  (dispatch) => {
    const opts = { source_code: sourceCode };

    return dispatch(
      gmiRequest({
        action: actions.reservations.commit(opts),
        loadingOverlay: true,
        redirect,
        onComplete: (response) => {
          if (!response.messages) {
            dispatch(closeModal());
            dispatch(openModal(MODAL.FLIGHT_CONFIRMED_MODAL));
          }
          return response;
        },
      })
    );
  };
